export const addClassToDefaultIfTrue = (defaultClass, booleanExpression, classToAdd) =>
  booleanExpression ? `${defaultClass} ${classToAdd}` : defaultClass;
